import { Spinner } from '@chakra-ui/react';
import React from 'react';
import dynamic from 'next/dynamic'
const ListingsComp = dynamic(() => import('../components/listings'), { ssr: true })
import { SpinnerHolder } from '../styles/ListingsStyles';
import Head from 'next/head'
import prisma from '../lib/prisma';
import { shuffle } from '../src/apiUtility';
const Listings = ({ 
    query, 
    linkList1, linkList1Header, 
    linkList2,
    linkList2Header, 
    listings, staticComing, countOfListings, coordinates, startListing, lastListing, pages, currentPage
}) => {

    if (!listings && staticComing) {
        return <SpinnerHolder>

            <Spinner size="xl" color="green.800" />
        </SpinnerHolder>
    }
    return (
        <>
        <Head>
            <title key="title">Search Businesses and Commercial Real Estate in Canada | zonado.com </title>
            {
                Number(query?.page) > 1 &&
                <meta name="robots" content="noindex" />
            }   
            <meta key="og:title"
                property="og:title"
                content={`Search businesses and commercial real estate listings${ Number(query?.page) > 1 ? ` | Page ${query.page}` : ''} | zonado.com`} />
            <link rel="canonical" href="https://zonado.com/listings" />
        </Head>
        <ListingsComp
            query={query}
            linkList1={linkList1}
            linkList1Header={linkList1Header}
            linkList2={linkList2}
            linkList2Header={linkList2Header}
            staticData={listings ? {
                listings,
                countOfListings, coordinates, startListing, lastListing, pages, currentPage
            }: null} 

            staticType={undefined} cleanedVariable={undefined} description={undefined} cleanedProvince={undefined} cleanedType={undefined} cleanedName={undefined} staticDesc={undefined}        />
            </>

    )

}

export default Listings;



export async function getServerSideProps({ query }) {
    // Only the plain, unfiltered /listings request gets real SSR content below.
    // Any filtered/paged query keeps using the existing client-side fetch to /api/listings,
    // which already handles arbitrary filter combinations.
    if (Object.keys(query).length === 0) {
        const listingsWhere = {
            status: {
                in: ['Available', 'Conditionally Sold'],
            },
            User: {
                slug: {
                    not: 'Corry-S'
                }
            }
        };

        const listingSelect = {
            id: true,
            subject: true,
            aiTagline: true,
            subType: true,
            propertyTypes: true,
            type: true,
            priceType: true,
            city: true,
            showAddress: true,
            price: true,
            unpriced: true, offMarket: true, imageOrder: true, imageURLs: true, imagesFresh: true,
            timeStamp: true,
            primaryImg: true,
            bedrooms: true,
            sqft: true,
            totalBuildingSize: true,
            lotSize: true,
            lotSizeUnit: true,
            cap: true,
            province: true,
            priority: true,
            distressed: true,
            grossRevenue: true,
            ebitda: true,
            employees: true,
            yearEstablished: true,
            businessType: true,
            businessCategory: true,
            User: {
                select: {
                    brokerage: true,
                    fullName: true,
                    photoURL: true,
                    industryRole: true,
                    pro: true,
                    plan: true
                }
            }
        };

        const [listings, coordinates, aggregations] = await Promise.all([
            prisma.listing.findMany({
                where: listingsWhere,
                take: 60,
                skip: undefined,
                select: listingSelect,
                orderBy: [
                    { priority: 'desc' },
                    { timeStamp: 'desc' },
                ]
            }),
            prisma.listing.findMany({
                where: listingsWhere,
                select: {
                    coordinates: true,
                    id: true
                }
            }),
            prisma.listing.aggregate({
                where: listingsWhere,
                _count: {
                    _all: true,
                },
            }),
        ]);

        // Move pro to the top
        const nonProListings = listings.filter(listing => listing['priority'] === 1);
        const proListings = shuffle(listings.filter(listing => listing['priority'] > 1));
        const proSortedListings = [...proListings, ...nonProListings];

        const {
            _count: {
                _all: countOfListings
            },
        } = aggregations;

        return {
            props: {
                query,
                staticComing: true,
                linkList1: null,
                linkList1Header: null,
                linkList2: null,
                linkList2Header: null,
                listings: JSON.parse(JSON.stringify(proSortedListings)),
                countOfListings,
                coordinates,
                startListing: 1,
                lastListing: countOfListings > 60
                    ? 60 : countOfListings,
                pages: Math.ceil(countOfListings / 60),
                currentPage: 1,
            } // will be passed to the page component as props
        }
    }

    return {
        props: {
            staticComing: false,
            linkList1: null,
            linkList1Header: null,
            linkList2: null,
            linkList2Header: null,
            query,
            listings: null
        }, // will be passed to the page component as props
    }
}